import { KeyDownHandler } from "UiBuildingBlocks/Infrastructure/KeyHandler";

export class HelpHandler {

  /**
     * get helpId of element
     * @returns {string}
     */
  public static getHelpId(): string {
    return HelpHandler._helpId;
  }

  /**
     * set helpId to element
     * @param helpId
     */
  public static setHelpId(helpId: string) {
    HelpHandler._helpId = helpId;
  }

  /**
     * register onhelpcallback to keypress
     * @param onHelp
     */
  public static registerHelpCallback(onHelp: (helpId: string) => void) {
    if (onHelp) {
      KeyDownHandler.push(this.onKeyDown.bind(this, onHelp));
    }
  }

  private static onKeyDown(onHelp: (helpId: string) => void, event: KeyboardEvent) {
    if (event.key === "F1") {
      let helpId = HelpHandler.getHelpId();
      if (helpId) {
        onHelp(helpId);
      } else {
        onHelp("");
      }
      event.preventDefault();
    }
  }
  public static _lastEventTarget: EventTarget;
  private static _helpId: string = null;
}